import React, { Fragment, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const DashboardViewNavigator = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { dashboardId, dashboardPageId } = params;

  useEffect(() => {
    if (
      !(
        dashboardId === 'null' ||
        dashboardId === 'undefined' ||
        dashboardPageId === 'null' ||
        dashboardPageId === 'undefined'
      )
    ) {
      navigate('/dashboards/view', {
        relative: 'path',
        state: { dashboardId, pageId: dashboardPageId },
        replace: true,
      });
    } else window.close();
  }, []);

  return <Fragment></Fragment>;
};

export default DashboardViewNavigator;
